import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="container mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold text-center text-brand-dark mb-12">我们的服务</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="card">
            <h2 className="text-2xl font-bold text-brand-dark mb-4">个人教练</h2>
            <p className="text-brand-text mb-4">
              一对一专业教练服务，帮助个人实现职业发展和个人成长目标。
            </p>
            <ul className="text-brand-text space-y-2">
              <li>• 职业发展规划</li>
              <li>• 领导力提升</li>
              <li>• 个人效能提升</li>
            </ul>
          </div>
          <div className="card">
            <h2 className="text-2xl font-bold text-brand-dark mb-4">企业教练</h2>
            <p className="text-brand-text mb-4">
              为组织提供领导力发展、团队建设和文化转型等专业教练服务。
            </p>
            <ul className="text-brand-text space-y-2">
              <li>• 领导力发展</li>
              <li>• 团队建设</li>
              <li>• 组织文化转型</li>
            </ul>
          </div>
          <div className="card">
            <h2 className="text-2xl font-bold text-brand-dark mb-4">教练培训</h2>
            <p className="text-brand-text mb-4">
              提供专业的教练认证培训课程，培养新一代教练人才。
            </p>
            <ul className="text-brand-text space-y-2">
              <li>• ICF认证课程</li>
              <li>• 实践指导</li>
              <li>• 持续学习支持</li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Services; 